require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-the-world-bank-is-proposing-a-300-million-loan-to.json") })
        }
      }, "path---en-us-update-the-world-bank-is-proposing-a-300-million-loan-to");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-the-world-bank-is-proposing-a-300-million-loan-to!./.cache/json/en-us-update-the-world-bank-is-proposing-a-300-million-loan-to.json
// module id = 808
// module chunks = 231608221292675